import React from 'react';

function ConsentContentPanel(props) {
  const { dataItem } = props;

  const html = dataItem.content || dataItem.errorMessage;
  return (
    <section>
      <iframe
        srcDoc={`<meta charset="utf-8"/>${html}`}
        id="content_iFrame"
        style={{
          border: 0,
          height: 600,
          width: '100%',
          paddingTop: 20,
        }}
        title="User Message"
      />
    </section>
  );
}

export default ConsentContentPanel;
